export default class {
  constructor(params) {
    params = params || {};
    this.fileName = params.fileName;
    this.ocxId = "_OCX_" + $uuid()
    this.ProductType = {
      NTKO_OFFICE: 1,
      SUWELL_OFD: 2,
      DJ_AIP: 3,
      KINGGRID_PDF: 4,
      KINGGRID_OFFICE: 5
    }
  }

  getHttpPath() {
    var locationhref = window.location;
    var portStr = "";
    if (locationhref.port != 80) {
      portStr = ":" + locationhref.port;
    }
    return this.httpPath = locationhref.protocol + "//" + locationhref.hostname + portStr;
  }

  on(key, func) {
    this.events[key] = func;
  }

  setOcx(ocx) {
    this.ocx = ocx;
  }

  /**
   * 渲染
   * @param to  {string} jquery选择元素
   * @param scope {jQuery|HTMLElement} 元素限定范围范围
   * @returns {*|jQuery|HTMLElement}
   */
  render(to, scope) {
    this.renderTo = to || this.renderTo;
    this.scope = scope || this.scope;
    var me = this;
    var tpl = this.tpl || this.getTpl();
    var iframeHtml = '<iframe scrolling="false" name="_OCX_EDITOR"   style="height:700px;width:100%;border:none;padding:0;margin:0;left:0;top:0;z-index:-999999;overflow:hidden;background-color:#fff;" src="about:blank"></iframe>';

    var iframe = $(iframeHtml);
    iframe.on("load", function () {
      var win = iframe[0].contentWindow;
      var doc = win.contentDocument || win.document;
      // doc.write(tpl);
      doc.body.innerHTML = tpl;
      var ocx = doc.getElementById(me.ocxId);
      me.setOcx(ocx);
      setTimeout(function () {
        if (me.events.load) {
          me.events.load.call(me);
        }
      }, 100)
    });
    this.el = iframe;
    if (this.renderTo) {
      if (this.renderTo) {
        $(this.renderTo, scope).append(iframe)
      }
    }
    return iframe;
  }

  /**
   * 重新渲染
   */
  rerender() {
    this.destroy();
    if (this.renderTo) {
      this.render(this.renderTo, this.scope);
    }
  }

  closeDocument() {

  }

  destroy() {
    this.closeDocument();
    this.ocx = null;
    if (this.el) {
      this.el.remove();
    }
    this.el = null;
  }

  getProduct() {
    return 0;
  }

  getTpl() {
    return "";
  }
}





// WEBPACK FOOTER //
// ./src/common/components/extend/ntko/src/ocx-base.js